import { render } from "./detail-armada.vue?vue&type=template&id=9dbe44fa&scoped=true"
import script from "./detail-armada.vue?vue&type=script&lang=js"
export * from "./detail-armada.vue?vue&type=script&lang=js"

import "./detail-armada.vue?vue&type=style&index=0&id=9dbe44fa&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dbe44fa"]])

export default __exports__